<div #editor class="simpleTextEditor" [class.--read-only]="readOnlyMode" id="simpleTextEditor-{{editorId}}"></div>
